import { TXP_OPTIONS_V2_FEATURE, TxpSettingsDataPointNames } from '../helpers/TxpConstants';
import TxpGriffinSettingsPayload from '../store/schema/TxpGriffinSettingsPayload';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';
import store from '../store/store';
import getUserSettingsAction from 'owa-calendar-configuration/lib/services/getUserSettingsAction';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logCalendarUsage } from 'owa-shared-analytics';
import { trace } from 'owa-trace';
import { mutatorAction } from 'satcheljs';

export default async function reloadTxpSettings(
    shouldLogDatapoint?: boolean,
    entryPoint?: TxpSettingsEntryPoint
) {
    if (isFeatureEnabled(TXP_OPTIONS_V2_FEATURE)) {
        try {
            const response = await getUserSettingsAction(shouldLogDatapoint, entryPoint);
            const responseStatus = response.status;

            setTxpSettings(responseStatus === 200 ? await response.json() : null, responseStatus);

            if (responseStatus !== 200) {
                logCalendarUsage(TxpSettingsDataPointNames.TXPSettingsResponseError, [
                    responseStatus,
                    response.statusText,
                ]);
            }
        } catch (e) {
            trace.warn('[TXP]' + e.message);
            logCalendarUsage(TxpSettingsDataPointNames.TXPSettingsResponseError, e.message);
        }
    }
}

const setTxpSettings = mutatorAction(
    'setTxpSettings',
    (response: TxpGriffinSettingsPayload, statusCode: number) => {
        store.txpSettings = response;
        store.statusCode = statusCode;
    }
);
